import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms'
import { AuthService } from '../auth.service'
import { AlertService } from '../../services/alert.service'
import { IUser } from '../../models/IUser'
import { PasswordValidation } from '../change-password/password-validation'
import { Router } from '@angular/router';
import { RecaptchaComponent } from 'ng-recaptcha';



@Component({
  templateUrl: 'register.component.html'
})

export class RegisterComponent implements OnInit {
  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  public isRequesting: boolean = false;
  public isSubmitted: boolean = false;
  public model: IUser = { password: '', friendlyName: '', email: '' };
  form: FormGroup;

  constructor(private router: Router,
    private authService: AuthService, private formBuilder: FormBuilder, private alertService: AlertService) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      friendlyName: [null, [Validators.required, Validators.minLength(3)]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    }, { validator: PasswordValidation.MatchPassword });

  }
  register(valid: boolean) {

    this.isRequesting = true;
    if (valid) {
      this.authService.register(this.model, '/dashboard');
      this.isRequesting = false;
    }
  }

  executeReCaptcha() {
    this.captchaRef.execute();
  }

  getReCaptchaResponse(response: string) {
    console.log(response);
    // this.form.patchValue({
    //     'g-recaptcha-response': response
    // });
    if (this.form.valid) {
      this.register(true);
    }



  }


}





// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/register/register.component.ts